// extracted by mini-css-extract-plugin
export default {"Vcard":"Transaction_Vcard__UY3nP","VAcctTxt":"Transaction_VAcctTxt__MEsP1","VFundTxt":"Transaction_VFundTxt__aD51P","VBank":"Transaction_VBank__6EBF9"};